import React, { useState, useEffect, Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import Button from "../form/Button";
import { classNames } from "../../helpers/classNames";

const ConfirmationPopup = ({
  isOpen,
  setIsOpen = () => {},
  getActionValue = () => {},
  title,
  message,
  confirmButtonLabel,
  cancelButtonLabel,
  setLoading = () => {},
  loading = false,
  headerIcon,
}) => {
  const closeModal = () => {
    setIsOpen(false);
    setLoading(false);
    getActionValue({
      button_type: "close",
      row_id: "",
      current_status: "",
    });
  };

  const onSubmit = () => {
    getActionValue({
      button_type: "confirm",
      row_id: "",
      current_status: "",
    });
  };

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={() => {}}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-2 text-left align-middle shadow-xl transition-all">
                  <div className="absolute top-2 right-2 z-10">
                    <Button
                      buttonLabelClasses=""
                      buttonType={"button"}
                      buttonIcon={"fa-light fa-times"}
                      buttonIconPosition={"left"}
                      buttonLabel={""}
                      buttonClasses={
                        "!bg-transparent !text-slate-700 !w-10 !h-10 !p-0 !border-transparent hover:!text-red-500"
                      }
                      buttonFunction={closeModal}
                      buttonHasLink={false}
                    />
                  </div>
                  <div className={classNames("md:py-2 py-2 md:px-6 px-4")}>
                    <div className="flex flex-col justify-center items-center gap-2">
                      <div className="flex justify-start w-full items-center">
                        {headerIcon ? (
                          headerIcon
                        ) : (
                          <i className="fa-regular fa-exclamation-triangle text-yellow-600 rounded-full mr-2 text-2xl"></i>
                        )}
                        <div className="text-lg font-bold pl-1">
                          {title ? title : "Confirmation"}
                        </div>
                      </div>
                      <hr className="w-full border-1 border-slate-400"></hr>
                      <div className="flex pt-6 text-sm text-gray-700 font-semibold text-center">
                        {message ? (
                          <p>{message}</p>
                        ) : (
                          <p>
                            {
                              "Reminder: Input all necessary information in the Position Competencies window."
                            }
                          </p>
                        )}
                      </div>
                      <div className="flex items-center gap-4 mt-3">
                        <Button
                          buttonLabelClasses=""
                          buttonType={"button"}
                          buttonIcon={"fa-solid fa-xmark"}
                          buttonIconPosition={"left"}
                          buttonLabel={
                            cancelButtonLabel ? cancelButtonLabel : "Cancel"
                          }
                          buttonClasses={
                            "!bg-rose-600 !border-transparent !text-base !rounded-lg !py-2 !px-6 !text-white  hover:!bg-rose-600/80"
                          }
                          buttonFunction={closeModal}
                          buttonHasLink={false}
                        />
                        <Button
                          buttonClasses={
                            "!bg-green-600 !border-green-600 hover:!bg-green-600/80 !rounded-lg"
                          }
                          buttonLabelClasses=""
                          buttonType={"button"}
                          buttonIcon={
                            loading
                              ? "fa-light fa-spinner fa-spin"
                              : "fa-light fa-check"
                          }
                          buttonIconPosition={"left"}
                          isLoaderDisabled={true}
                          buttonLabel={
                            confirmButtonLabel ? confirmButtonLabel : "Confirm"
                          }
                          buttonFunction={onSubmit}
                          buttonHasLink={false}
                          buttonDisabled={loading}
                        />
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};
export default ConfirmationPopup;
